export default "__VITE_ASSET__smQGl50___"